<template>
  <div>
    <h3 class="text-primary">
      <i class="fa fa-ticket me-2"></i> {{ $t("tickets.myTickets") }}
    </h3>
    <p class="text-muted">{{ $t("tickets.info") }}</p>

    <!-- Listă Bilete -->
    <div class="table-responsive" v-if="tickets && tickets.length">
      <table class="table table-striped table-hover rounded">
<thead class="bg-primary text-white">
  <tr class="text-center">
    <th><i class="fa fa-car me-1"></i> {{ $t("tickets.product") }}</th>
    <th><i class="fa fa-user me-1"></i> {{ $t("tickets.client") }}</th>
    <th><i class="fa fa-calendar me-1"></i> {{ $t("tickets.daysRemaining") }}</th>
    <th><i class="fa fa-check-circle me-1"></i> {{ $t("tickets.status") }}</th>
    <th><i class="fa fa-cogs me-1"></i> {{ $t("tickets.actions") }}</th>
  </tr>
</thead>

        <tbody>
          <tr v-for="ticket in tickets" :key="ticket.barcode" class="text-center">
            <td class="">{{ ticket.product_name }}</td>
            <td class="">{{ ticket.client }}</td>
            <td :class="getDaysClass(ticket.days_remaining)">
              {{ ticket.days_remaining }} {{ $t("tickets.days") }}
            </td>
<td>
  <span class="badge" :class="getStatusClass(normalizeTicketStatus(ticket))">
    {{ getStatusLabel(normalizeTicketStatus(ticket)) }}
  </span>
</td>

            <td>
              <button v-if="ticket.barcode" class="btn btn-outline-primary btn-sm"
                @click="downloadPDF(ticket.barcode)">
                <i class="fa fa-ticket me-1"></i> {{ $t("tickets.viewTicket") }}
              </button>



              <span v-else class="text-muted">{{ $t("tickets.noInvoice") }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Mesaj dacă nu există bilete -->
    <div v-else class="alert alert-warning text-center">
      <i class="fa fa-info-circle me-2"></i> {{ $t("tickets.noTickets") }}
    </div>
  </div>
</template>


<style scoped>
/* Table Styling */
.table {
  border-radius: 8px;
  overflow: hidden;
  background: #f8f9fa;
}

.table thead {
  background-color: #007bff !important;
}

.table tbody tr:hover {
  background: rgba(0, 123, 255, 0.1);
}



/* Status Colors */
.text-success {
  color: #28a745 !important;
}

.text-warning {
  color: #ffc107 !important;
}

.text-danger {
  color: #dc3545 !important;
}

/* Buttons */
.btn-outline-primary,
.btn-outline-danger {
  transition: 0.3s ease;
}

.btn-outline-primary:hover {
  background-color: #0056b3;
  color: #fff;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  color: #fff;
}
</style>
<script>
import axios from "axios";

export default {
  name: "MyTickets",
  data() {
    return {
      tickets: [],
    };
  },
  async mounted() {
    await this.fetchTickets();
  },
  methods: {
async fetchTickets() {
  try {
    const response = await axios.get("https://api.feribot-eurobac.ro/client/api/bilete/", {
      withCredentials: true,
    });

    if (response.data && Array.isArray(response.data.bilete)) {
      this.tickets = response.data.bilete; // Ajustează la "bilete"
    } else {
      this.tickets = [];
      console.error("API nu a returnat un array valid:", response.data);
    }
  } catch (error) {
    console.error("Eroare la preluarea biletelor:", error);
    this.tickets = [];
  }
}

,
    async downloadPDF(barcode) {
      try {
        const response = await axios.get(`https://api.feribot-eurobac.ro/client/api/bilete/${barcode}/pdf/`, {
          withCredentials: true,
          responseType: "blob",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Bilet_${barcode}.pdf`;
        link.click();
      } catch (error) {
        console.error("Eroare la descărcarea PDF-ului:", error);
      }
    },
async downloadInvoicePDF(invoiceId) {
  try {
    const response = await axios.get(`https://api.feribot-eurobac.ro/api/invoices/online/${invoiceId}/pdf/`, {
      withCredentials: true,
      responseType: "blob", // Necesită responseType pentru a descărca fișierul corect
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `Factura_${invoiceId}.pdf`;
    link.click();
  } catch (error) {
    console.error("Eroare la descărcarea facturii PDF:", error);
  }
},
    getStatusLabel(status) {
      const statuses = {
        active: this.$t("tickets.statusActive"),
        used: this.$t("tickets.statusUsed"),
        expired: this.$t("tickets.statusExpired"),
      };
      return statuses[status] || status;
    },
    
    getStatusClass(status) {
      return {
        active: "badge bg-success",
        used: "badge bg-warning text-dark",
        expired: "badge bg-danger",
      }[status];
    },
    getDaysClass(daysRemaining) {
      if (daysRemaining > 5) return "text-success fw-bold";
      if (daysRemaining <= 5 && daysRemaining > 0) return "text-warning fw-bold";
      return "text-danger fw-bold";
    },normalizeTicketStatus(ticket) {
  if (ticket.status === "active" && ticket.days_remaining <= 0) {
    return "expired";
  }
  return ticket.status;
}


  },
};
</script>



  